<div class="flex flex-col gap-24 py-32">
	<div class="flex flex-col md:flex-row justify-center items-center gap-4">
		<h1 class="text-5xl z-30 text-center uppercase">{{ 'page.privacy.title-on-page' | translate }}</h1>
	</div>

	<div class="w-6/12 mx-auto font-notosans text-justify whitespace-pre-wrap flex flex-col justify-center gap-16">
		<p>{{ 'page.privacy.header' | translate }}</p>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_1.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_1.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_2.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_2.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_3.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_3.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_4.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_4.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_5.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_5.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_6.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_6.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_7.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_7.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_8.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_8.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_9.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_9.content' | translate }}</p>
		</div>
		<div class="flex flex-col gap-4">
			<h2 class="font-bold text-2xl">{{ 'page.privacy.article_10.title' | translate }}</h2>
			<p>{{ 'page.privacy.article_10.content' | translate }}</p>
		</div>
	</div>
</div>
